import { useSpacesContext } from "@circle-react/contexts/spacesContext";

import { useSpaceSlugFromUrl } from "@/react/hooks/useSpaceSlugFromUrl";

export const useEventSpaces = () => {
  const spaceContext = useSpacesContext();
  const spaceSlug = useSpaceSlugFromUrl();
  const spaces = spaceContext.helpers.spacesWithPostCreationAllowed() || [];
  const eventSpaces = spaces.filter(space => space.post_type === "event");
  const spaceId =
    eventSpaces.find(space => space.slug === spaceSlug)?.id || null;
  return {
    spaces: eventSpaces,
    spaceId,
  };
};
